export default "__VITE_ASSET__MMAo6bbJ__"